// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"SectionHeader-module--section-header--K7cXz","subtitle":"SectionHeader-module--subtitle--1rkJb"};